import * as actionTypes from "../../actions/actionTypes";
const changePassword = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_CHANGE_PASSWORD:
      return { ...state, ...action.payload };
    case actionTypes.CLEAR_CHANGE_PASSWORD:
      return {};
    default:
      return state;
  }
};

export default changePassword;
